// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__5fbTa","sub_container":"WordGameLayout_sub_container__FN0a5"};